import { createSelector } from "@reduxjs/toolkit";
import { cartApi } from "./api/cartApi";

// Input selector: Selects the result of the 'getCart' query from the API slice state.
// This gives us access to the query's status, data, error, etc.
const selectCartResult = cartApi.endpoints.getCart.select();

/**
 * Memoized selector to get the total number of items in the cart.
 * It derives this value from the `getCart` query result.
 * It provides a default value of 0 if the cart data is not available.
 */
export const selectCartCount = createSelector(
  [selectCartResult],
  (cartResult) => {
    // cartResult.data is our TransformedCart object
    const count = cartResult.data?.itemsCount ?? 0;
    return count;
  }
);
